import { DrawerLabel } from '../../components/drawer/DrawerLabel';

export const ToggleSectionHeader: React.FC<{ label: string }> = ({ label }) => {
    return (
        <div>
            <DrawerLabel text={label} />
        </div>
    );
};
